import {FC, MutableRefObject, useEffect, useState} from 'react';

import {Box} from '@mui/material';

import {BasketLineItem} from 'types';

import {ProductThumbnail} from './ProductThumbnail';
import {ProductSummaryListStyled} from './styles';
import {ProductWithQuantity} from './types';

export interface ProductSummaryListProps {
  products: BasketLineItem[];
  parentRef: MutableRefObject<HTMLDivElement | undefined>;
}

export const ProductSummaryList: FC<ProductSummaryListProps> = (props) => {
  const {products, parentRef} = props;

  const productListWithQuantity: ProductWithQuantity[] = products.map((product: BasketLineItem) => {
    return {
      basketProductId: product.id as string,
      imageURl: product.productDetails.imageUrls[0],
      quantity: product.quantity,
      title: product.productDetails.title,
      isWeightedFresh: !!product.productDetails.isWeightedFresh,
      moq: product.productDetails?.moq || 1
    };
  });

  const [maxImagesShown, setMaxImagesShown] = useState(productListWithQuantity.length);

  const onWindowResize = () => {
    const maxItems = Math.floor((parentRef.current?.clientWidth as number) / 58);

    if (productListWithQuantity.length < maxItems) {
      setMaxImagesShown(productListWithQuantity.length);
    } else if (maxItems != maxImagesShown) {
      setMaxImagesShown(maxItems);
    }
  };

  useEffect(() => {
    onWindowResize();
    window.addEventListener('resize', onWindowResize);
    return () => {
      window.removeEventListener('resize', onWindowResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const productsListToRender = productListWithQuantity.slice(0, maxImagesShown);

  return (
    <ProductSummaryListStyled>
      <Box display={'flex'} flexDirection={'row'} columnGap={1}>
        {productsListToRender.map((product, index) => {
          const isMoreProductsAvailable =
            index === productsListToRender.length - 1 && productListWithQuantity.length > maxImagesShown;

          return (
            <ProductThumbnail
              key={product.basketProductId}
              product={product}
              isMoreProductsAvailable={isMoreProductsAvailable}
              leftQuantity={productListWithQuantity.length - maxImagesShown}
            />
          );
        })}
      </Box>
    </ProductSummaryListStyled>
  );
};

ProductSummaryList.displayName = 'ProductSummaryList';
